import React, { useEffect } from "react";
import Servicebanner from "../../Services/Servicebanner";
import NumberInfo from "../../Home/NumberInfo";
import Doctorbox from "../../Home/Docterbox";
import Divser from "../../About/Divser";
import Divider from "../../Divider";
import ServiceReview from "../../Services/ServiceReview";
import Callin from "../../About/Callin";
import Infiry from "../../About/Infiry";
import Psychiatrycon from "./Psychiatrycon";
import { movetop } from "../../../fun";
import { Helmet } from "react-helmet-async";

function Psychiatry() {
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <Psychiatrycon />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };

  useEffect(() => {
    movetop();
  }, []);
  return (
    <>
      <Helmet>
        <title>Best Psychiatrist in Whitefield</title>
        <meta
          name="description"
          content="We have the Best Psychiatrist in Whitefield and Vijayanagar. If you are looking for this then contact us today or call us now."
        />
        <meta
          name="keywords"
          content="Best Psychiatrist in Whitefield, Best Psychiatrist in Vijayanagar, healthcare services in Whitefield, healthcare services in Vijayanagar, Multispeciality Clinic in Vijayanagar"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id":
              "https://www.elvhealthcare.com/bestpsychiatryservicesinwhitefield#organization",
            name: "ELV Health Care Polyclinics",
            url: "https://www.elvhealthcare.com/bestpsychiatryservicesinwhitefield",
            description:
              "ELV Health Care Polyclinics in Whitefield offers psychiatry services for mental health assessment, diagnosis, and personalized treatment plans for conditions such as anxiety, depression, stress, sleep issues, and mood disorders—delivered with confidentiality and compassionate care.",
            logo: "https://www.elvhealthcare.com/favicon.ico",
            telephone: ["+91-9535264855", "+91-9535264854"],
            email: "elvhealthcare@gmail.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 12.9764418,
              longitude: 77.7583566,
            },
            hasMap: "https://maps.app.goo.gl/C1xXW4kQyTxR8Sug9",
            knowsAbout: [
              "Psychiatric consultation and diagnosis",
              "Anxiety and depression management",
              "Stress and burnout support",
              "Sleep disorder evaluation and care",
              "Mood disorder treatment planning",
              "Medication management and follow-ups",
              "Counseling coordination and referrals",
              "Confidential mental health care",
            ],
            keywords: [
              "best psychiatry services in Immadihalli",
              "best psychiatry services in Whitefield",
              "best psychiatry services in Bangalore",
              "best psychiatry services in Kundalahalli",
              "best psychiatry services in Pattandur Agrahara",
            ],
          })}
        </script>
      </Helmet>
      <h2 style={{ display: "none" }}>
        Best Psychiatrist in Whitefield service sets us apart as a leader in
        Psychiatry services. Contact us for the best Psychiatrist in Whitefield.
      </h2>
      <Servicebanner name="Psychiatry" banner={"../photo/dd22.jpg"} />
      <NumberInfo test="test-black" />
      <Doctorbox />
      <Divser elemnt={elemnt} />
      {/* <div className="pt-6">
            <Divider />
          </div>
          <Doctorbox /> */}
      <div className="pt-10 pb-4">
        <Divider />
      </div>
      <ServiceReview />
    </>
  );
}

export default Psychiatry;
